import {
  IconAirfare,
  type IconElement,
  IconHotel,
  IconLabour,
  IconMeals,
  IconMileage,
  IconReceipt,
  renderIcon,
} from '@procurify/ui'

import {
  ExpenseTypes,
  type ExpenseTypeEnum,
} from '@webapp/modules/expense/entities/enums/ExpenseTypeEnum'
import { useFormatExpenseItemTypeLabel } from '@webapp/modules/expense/hooks/useFormatExpenseItemTypeLabel'
import { ExpenseTypeSelectorContainerStyled } from './styles/ExpenseTypeSelectorContainerStyled'
import { ExpenseTypeTileIconStyled } from './styles/ExpenseTypeTileIconStyled'
import { ExpenseTypeTileLabelStyled } from './styles/ExpenseTypeTileLabelStyled'
import { ExpenseTypeTilesRowStyled } from './styles/ExpenseTypeTilesRowStyled'
import { ExpenseTypeTileStyled } from './styles/ExpenseTypeTileStyled'

const EXPENSE_TYPE_ICON_MAP: Record<ExpenseTypeEnum, IconElement> = {
  [ExpenseTypes.OTHER]: <IconReceipt />,
  [ExpenseTypes.MEALS]: <IconMeals />,
  [ExpenseTypes.MILEAGE]: <IconMileage />,
  [ExpenseTypes.LABOUR]: <IconLabour />,
  [ExpenseTypes.AIRFARE]: <IconAirfare />,
  [ExpenseTypes.LODGING]: <IconHotel />,
}

const EXPENSE_TYPE_ORDER: ExpenseTypeEnum[] = [
  ExpenseTypes.OTHER,
  ExpenseTypes.AIRFARE,
  ExpenseTypes.LABOUR,
  ExpenseTypes.LODGING,
  ExpenseTypes.MEALS,
  ExpenseTypes.MILEAGE,
]

interface IExpenseTypeSelectorProps {
  value: ExpenseTypeEnum
  onChange: (expenseType: ExpenseTypeEnum) => void
  disabled?: boolean
}

export const ExpenseTypeSelector = ({
  value,
  onChange,
  disabled = false,
}: IExpenseTypeSelectorProps) => {
  const formatExpenseItemTypeLabel = useFormatExpenseItemTypeLabel()

  return (
    <ExpenseTypeSelectorContainerStyled>
      <ExpenseTypeTilesRowStyled>
        {EXPENSE_TYPE_ORDER.map((expenseType) => {
          const isActive = value === expenseType
          return (
            <ExpenseTypeTileStyled
              key={expenseType}
              type='button'
              isActive={isActive}
              isDisabled={disabled}
              disabled={disabled}
              onClick={() => onChange(expenseType)}
            >
              <ExpenseTypeTileIconStyled isActive={isActive}>
                {renderIcon(EXPENSE_TYPE_ICON_MAP[expenseType], { size: 24 })}
              </ExpenseTypeTileIconStyled>
              <ExpenseTypeTileLabelStyled isActive={isActive}>
                {formatExpenseItemTypeLabel(expenseType)}
              </ExpenseTypeTileLabelStyled>
            </ExpenseTypeTileStyled>
          )
        })}
      </ExpenseTypeTilesRowStyled>
    </ExpenseTypeSelectorContainerStyled>
  )
}
